import { ThongTinBienLai } from "./../../../pages/he-thong/cau-hinh/CauHinhHeThongPage";
import { v4 as uuidv4 } from "uuid";
import {
  IThuPhiTab,
  IThuPhiThongTinBienLai,
} from "../../../model/request/thu-phi/IThuPhiTab";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { IThuPhiActionTypes } from "../../action-types/thu-phi/IThuPhiActionTypes";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThuPhiReducer } from "../../reducer-model/thu-phi/IThuPhiReducer";
import { IQRCodeResponse } from "../../../model/respone/ngan-hang/IQRCodeResponse";

const iniTab: IThuPhiTab = {
  id: uuidv4(),
  title: "Untitled",
  mucThuKhacs: [],
  mucThuKhacSelectedIds: [],
  step: 0,
  hinhThucNops: [],
  status: eReducerStatusBase.is_not_initialization,
  hocKy: 0,
  namHoc: "",
  qrCode: {
    bank_code_vnpay: "",
    id_encode: 0,
    qrcode: "",
    show_modal: false,
  } as IQRCodeResponse,
  thongTinBienLai: {
    bienLaiId: 0,
    bienLaiPhieuThu: "",
    bienLaiTempPhieuThu: "",
    loaiBienLai: "thu",
    ngayThu: undefined,
    chiTuBienLaiId: 0,
  } as IThuPhiThongTinBienLai,
};
const iniState: IThuPhiReducer = {
  selectedId: iniTab.id,
  tabs: [iniTab],
};
export const thuPhiReducer = (
  state: IThuPhiReducer = iniState,
  action: IThuPhiActionTypes,
): IThuPhiReducer => {
  switch (action.type) {
    case "THU_PHI_ADD_NEW_TAB":
      let exist = state.tabs.find(
        (g) =>
          g.sinhVien?.id_sv === action.payload?.id_sv &&
          g.thongTinBienLai.bienLaiId <= 0,
      );
      const id = exist?.id ?? uuidv4();
      return {
        ...state,
        selectedId: id,
        tabs: exist
          ? [...state.tabs]
          : [
              {
                ...iniTab,
                title: action.payload?.ho_ten ?? "Untitled",
                id: id,
                sinhVien: action.payload,
              },
              ...state.tabs,
            ],
      };
    case "THU_PHI_RENEW_TAB_BY_ID":
      var id_tab_new = uuidv4();
      return {
        ...state,
        selectedId: id_tab_new,
        tabs: [
          ...state.tabs.filter((x) => x.id !== action.payload.id),
          {
            ...iniTab,
            title: action.payload.data.ho_ten ?? "Untitled",
            id: id_tab_new,
            sinhVien: action.payload.data,
          },
        ],
      };
    case "THU_PHI_REMOVE_TAB":
      return {
        ...state,
        tabs: state.tabs.filter((t) => t.id !== action.payload),
      };
    case "THU_PHI_UPDATE_TAB_DATA":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return action.payload;
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGEG_SELECTED_TAB":
      return {
        ...state,
        selectedId: action.payload,
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_loading,
              step: t.thongTinBienLai.bienLaiId > 0 ? t.step : 0,
              hocKy: action.payload.hoc_ky,
              namHoc: action.payload.nam_hoc,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs: action.payload.data,
              hinhThucNops: [],
              mucThuKhacSelectedIds: [],
              // step: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs: [],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_MUC_THU_KHAC_SELECTED_IDs":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let muc_thu_selected_id_news = action.payload.data.filter(
              (item) => !t.mucThuKhacSelectedIds.includes(item),
            );
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacSelectedIds: action.payload.data,
              mucThuKhacs: t.mucThuKhacs.map((g) => {
                if (action.payload.data.includes(g.id)) {
                  if (muc_thu_selected_id_news?.includes(g.id)) {
                    return {
                      ...g,
                      so_tien_thuc_nop: Math.abs(
                        g.lop_tin_chis && g.lop_tin_chis.length > 0
                          ? g.lop_tin_chis.reduce(
                              (a, b) => a + (b.so_tien_con_lai ?? 0),
                              0,
                            )
                          : g.so_tien_con_lai < 0
                            ? 0
                            : g.so_tien_con_lai,
                      ),
                      lop_tin_chis: g?.lop_tin_chis
                        ?.filter((ltc) =>
                          t.thongTinBienLai.loaiBienLai === "thu"
                            ? (ltc.so_tien_con_lai ?? 0) > 0
                            : false,
                        )
                        .map((ltc) => {
                          return {
                            ...ltc,
                            is_choose: true,
                            so_tien_thuc_nop: Math.abs(
                              ltc.so_tien_con_lai ?? 0,
                            ),
                          };
                        }),
                    };
                  }
                  return g;
                }
                return {
                  ...g,
                  so_tien_thuc_nop: 0,
                  lop_tin_chis: g?.lop_tin_chis?.map((ltc) => {
                    return {
                      ...ltc,
                      is_choose: false,
                      so_tien_thuc_nop: 0,
                    };
                  }),
                };
              }),
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_STEP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              step: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_HINHTHUCNOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CREATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_saving,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CREATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CREATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_completed,
              bienLaiId: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_EDIT_BIENLAI_SUCCESS": {
      const detail = action.payload.data;
      const chiTiets = detail?.bienLaiThuChiTiets ?? [];
      // chi tiết tín chỉ mang id_mon_tc; chi tiết thường mang id_thu_chi (id_mon_tc = 0).
      const soTienByMonTc: { [key: number]: number } = {};
      const soTienByThuChi: { [key: number]: number } = {};
      chiTiets.forEach((c: any) => {
        if (c.id_mon_tc && c.id_mon_tc !== 0) {
          soTienByMonTc[c.id_mon_tc] =
            (soTienByMonTc[c.id_mon_tc] ?? 0) + c.so_tien;
        } else {
          soTienByThuChi[c.id_thu_chi] =
            (soTienByThuChi[c.id_thu_chi] ?? 0) + c.so_tien;
        }
      });
      // Phiếu CHI: khoản nạp theo biên lai NGUỒN đang tính CẢ phần "đã chi" của chính phiếu đang sửa →
      // Còn lại bị thiếu. CỘNG LẠI phần chi của phiếu này vào Còn lại (và trừ khỏi Đã chi) để sửa lại được đủ.
      const isChi = !!detail?.thu_chi;
      const chiNguonIds: number[] = (detail?.chi_nguon_bien_lai_ids ?? []).filter(
        (x: number) => x > 0,
      );
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            const mucThuKhacs = t.mucThuKhacs.map((g) => {
              if (g.lop_tin_chis && g.lop_tin_chis.length) {
                let total = 0;
                const lop_tin_chis = g.lop_tin_chis.map((l) => {
                  if (l.id_mon_tc && soTienByMonTc[l.id_mon_tc] != null) {
                    const st = soTienByMonTc[l.id_mon_tc];
                    total += st;
                    return {
                      ...l,
                      is_choose: true,
                      so_tien_thuc_nop: st,
                      // Lop tín chỉ chỉ có so_tien_con_lai (không có so_tien_da_chi) → chỉ cộng lại Còn lại.
                      so_tien_con_lai: isChi
                        ? (l.so_tien_con_lai ?? 0) + st
                        : l.so_tien_con_lai,
                    };
                  }
                  return { ...l, is_choose: false, so_tien_thuc_nop: 0 };
                });
                return {
                  ...g,
                  lop_tin_chis,
                  so_tien_thuc_nop: total,
                  so_tien_con_lai: isChi
                    ? (g.so_tien_con_lai ?? 0) + total
                    : g.so_tien_con_lai,
                };
              }
              const prefill = soTienByThuChi[g.id_thu_chi] ?? 0;
              return {
                ...g,
                so_tien_thuc_nop: prefill,
                so_tien_con_lai: isChi
                  ? (g.so_tien_con_lai ?? 0) + prefill
                  : g.so_tien_con_lai,
                so_tien_da_chi: isChi
                  ? Math.max(0, (g.so_tien_da_chi ?? 0) - prefill)
                  : g.so_tien_da_chi,
              };
            });
            const selectedIds = mucThuKhacs
              .filter((g) => (g.so_tien_thuc_nop ?? 0) > 0)
              .map((g) => g.id);
            return {
              ...t,
              editingBienLaiId: detail.id_bien_lai,
              editingSoPhieu: `${detail.so_phieu_header ?? ""}${detail.so_phieu ?? ""}`,
              editingSoTien: detail.so_tien,
              step: 0,
              status: eReducerStatusBase.is_completed,
              mucThuKhacs,
              mucThuKhacSelectedIds: selectedIds,
              hinhThucNops: (detail.bienLaiThuHinhThucNops ?? []).map(
                (h: any, idx: number) => ({
                  id: idx,
                  so_tien: h.so_tien,
                  acc_bienlaithu_hinhthucnoptien_id:
                    h.acc_bienlaithu_hinhthucnoptien_id,
                  acc_bienlaithu_hinhthucnoptien_name:
                    h.acc_bienlaithu_hinhthucnoptien_name ?? "",
                  ghi_chu: h.ghi_chu ?? "",
                  id_bien_lai: detail.id_bien_lai,
                }),
              ),
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: 0,
                bienLaiTempPhieuThu: "",
                loaiBienLai: detail.thu_chi ? "chi" : "thu",
                // Phiếu chi: luôn dùng đường "gộp nhiều nguồn" (chiTuBienLaiId=0 + chiTuBienLaiIds) — kể cả 1 nguồn.
                chiTuBienLaiId: 0,
                chiTuBienLaiIds: isChi ? chiNguonIds : [],
                ngayThu: detail.ngay_thu
                  ? new Date(detail.ngay_thu)
                  : t.thongTinBienLai.ngayThu,
                idCoSo: detail.id_co_so ?? t.thongTinBienLai.idCoSo,
              },
            };
          }
          return t;
        }),
      };
    }
    case "THU_PHI_CANCEL_EDIT_BIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return {
              ...t,
              editingBienLaiId: 0,
              editingSoPhieu: undefined,
              editingSoTien: undefined,
              mucThuKhacSelectedIds: [],
              hinhThucNops: [],
              step: 0,
              status: eReducerStatusBase.is_need_reload,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: 0,
                bienLaiTempPhieuThu: "",
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_BIENLAITHU_START":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.id_sv) {
            return { ...t, status: eReducerStatusBase.is_saving };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              editingBienLaiId: 0,
              editingSoPhieu: undefined,
              editingSoTien: undefined,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiId: action.payload.data,
              },
              step: 2,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_BIENLAITHU_ERROR":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return { ...t, status: eReducerStatusBase.is_completed };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_MUC_THU_KHAC_SELECTED_IDs_LOP_TIN_CHI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacs: [
                ...t.mucThuKhacs.map((mtk: IMucThuKhacSinhVienViewModel) => {
                  if (mtk.lop_tin_chis && mtk.lop_tin_chis.length > 0) {
                    const lop_tin_chis_choose = mtk.lop_tin_chis.filter((g) =>
                      action.payload.data.includes(g.id_lop_tc),
                    );
                    const { so_tien, so_tien_mien_giam, so_tien_da_nop } =
                      lop_tin_chis_choose.reduce(
                        (acc, item) => {
                          acc.so_tien += item.hoc_phi_theo_hoc_phan;
                          acc.so_tien_mien_giam += item.so_tien_mg_neu_co || 0;
                          if (item.is_da_nop_du)
                            acc.so_tien_da_nop += item.hoc_phi_theo_hoc_phan;
                          return acc;
                        },
                        { so_tien: 0, so_tien_mien_giam: 0, so_tien_da_nop: 0 },
                      );
                    return {
                      ...mtk,
                      so_tien_thuc_nop: Math.abs(
                        so_tien - so_tien_mien_giam - so_tien_da_nop,
                      ),
                      lop_tin_chis: mtk.lop_tin_chis.map((ltc) => {
                        return {
                          ...ltc,
                          is_choose: action.payload.data.includes(
                            ltc.id_lop_tc,
                          ),
                          so_tien_thuc_nop: action.payload.data.includes(
                            ltc.id_lop_tc,
                          )
                            ? Math.abs(
                                ltc.hoc_phi_theo_hoc_phan -
                                  (ltc?.so_tien_mg_neu_co ?? 0) -
                                  (ltc?.so_tien_da_nop ?? 0),
                              )
                            : 0,
                        };
                      }),
                    };
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_SO_TIEN_THUC_NOP":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacSelectedIds: [
                ...t.mucThuKhacSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id ?? 0),
                ),
                action.payload.data > 0 ? (action.payload.request?.id ?? 0) : 0,
              ],
              mucThuKhacs: [
                ...t.mucThuKhacs.map((mtk: IMucThuKhacSinhVienViewModel) => {
                  if (mtk.id === action.payload.request.id) {
                    if (action.payload.request.id_lop_tc) {
                      return {
                        ...mtk,
                        lop_tin_chis: mtk.lop_tin_chis?.map((ltc) => {
                          if (
                            ltc.id_lop_tc === action.payload.request.id_lop_tc
                          ) {
                            return {
                              ...ltc,
                              so_tien_thuc_nop: action.payload.data,
                              is_choose: action.payload.data > 0,
                            };
                          }
                          return ltc;
                        }),
                        so_tien_thuc_nop: mtk.lop_tin_chis
                          ?.filter(
                            (g) =>
                              g.id_lop_tc !== action.payload.request.id_lop_tc,
                          )
                          ?.reduce(
                            (a, b) => a + (b.so_tien_thuc_nop ?? 0),
                            action.payload.data,
                          ),
                      };
                    } else {
                      return {
                        ...mtk,
                        so_tien_thuc_nop: action.payload.data,
                      };
                    }
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_GHI_CHU_KHOAN":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              mucThuKhacs: t.mucThuKhacs.map(
                (mtk: IMucThuKhacSinhVienViewModel) =>
                  mtk.id === action.payload.request.id
                    ? { ...mtk, ghi_chu_dong: action.payload.data }
                    : mtk,
              ),
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_DIEU_CHINH_GIAM_DINH_MUC":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              hinhThucNops: [],
              mucThuKhacSelectedIds: [
                ...t.mucThuKhacSelectedIds.filter(
                  (g) => g !== (action.payload.request?.id ?? 0),
                ),
                action.payload.request?.id ?? 0,
              ],
              mucThuKhacs: [
                ...t.mucThuKhacs.map((mtk: IMucThuKhacSinhVienViewModel) => {
                  if (mtk.id === action.payload.request.id) {
                    if (action.payload.request.id_lop_tc) {
                      return {
                        ...mtk,
                        is_dieu_chinh_dinh_muc: action.payload.data,
                        lop_tin_chis: mtk.lop_tin_chis?.map((ltc) => {
                          if (
                            ltc.id_lop_tc === action.payload.request.id_lop_tc
                          ) {
                            return {
                              ...ltc,
                              is_dieu_chinh_dinh_muc: action.payload.data,
                              is_choose: true,
                            };
                          }
                          return ltc;
                        }),
                      };
                    } else {
                      return {
                        ...mtk,
                        is_dieu_chinh_dinh_muc: action.payload.data,
                      };
                    }
                  }
                  return mtk;
                }),
              ],
            };
          }
          return t;
        }),
      };
    case "THU_PHI_CHANGE_THONGTINBIENLAI":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            let obj = {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                ...action.payload.data,
              },
            };
            if ("loaiBienLai" in action.payload.data) {
              obj = {
                ...obj,
                mucThuKhacs: [],
                mucThuKhacSelectedIds: [],
                hinhThucNops: [],
                step: 0,
                status: eReducerStatusBase.is_need_reload,
              };
            }
            return obj;
          }
          return t;
        }),
      };
    case "THU_PHI_LOAD_MUC_THU_KHAC_START_BY_MUCTHUID":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (
            action.payload.filter((value) =>
              t.mucThuKhacs.map((p) => p.id).includes(value),
            ).length > 0 &&
            t.thongTinBienLai.bienLaiId <= 0
          ) {
            return {
              ...t,
              status: eReducerStatusBase.is_need_reload,
              hinhThucNops: [],
              mucThuKhacs: [],
              mucThuKhacSelectedIds: [],
              step: 0,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_PREVIEW_BIENLAITHU_SUCCESS":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: action.payload.data,
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_PREVIEW_BIENLAITHU_CLOSE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.sinhVien?.id_sv === action.payload.request.id_sv) {
            return {
              ...t,
              thongTinBienLai: {
                ...t.thongTinBienLai,
                bienLaiTempPhieuThu: "",
              },
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_QRCODE":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              qrCode: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_QRCODES":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              qrCodes: action.payload.data,
            };
          }
          return t;
        }),
      };
    case "THU_PHI_UPDATE_GENQR_LOADING":
      return {
        ...state,
        tabs: state.tabs.map((t) => {
          if (t.id === action.payload.id) {
            return {
              ...t,
              genQRLoading: action.payload.data,
            };
          }
          return t;
        }),
      };
    default:
      return state;
  }
};
